'use strict';

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errCode = require('err-code');

var CID = require('cids');
/**
 * Transform one of:
 *
 * ```ts
 * CID
 * String
 * { cid: CID recursive, metadata }
 * { path: String recursive, metadata }
 * Iterable<CID>
 * Iterable<String>
 * Iterable<{ cid: CID recursive, metadata }>
 * Iterable<{ path: String recursive, metadata }>
 * AsyncIterable<CID>
 * AsyncIterable<String>
 * AsyncIterable<{ cid: CID recursive, metadata }>
 * AsyncIterable<{ path: String recursive, metadata }>
 * ```
 * Into:
 *
 * ```ts
 * AsyncIterable<{ path: CID|String, recursive:boolean, metadata }>
 * ```
 *
 * @param {Source} input
 * @returns {AsyncIterable<Pin>}
 */
// eslint-disable-next-line complexity


module.exports =
/*#__PURE__*/
function () {
  var _normaliseInput = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(input) {
    var iterator, first, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, cid, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, obj, _iterator5, _first, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _cid, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, _obj;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(input === null || input === undefined)) {
              _context.next = 2;
              break;
            }

            throw errCode(new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 2:
            if (!CID.isCID(input)) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return toPin({
              cid: input
            });

          case 5:
            return _context.abrupt("return");

          case 6:
            if (!(input instanceof String || typeof input === 'string')) {
              _context.next = 10;
              break;
            }

            _context.next = 9;
            return toPin({
              path: input
            });

          case 9:
            return _context.abrupt("return");

          case 10:
            if (!(input.cid != null || input.path != null)) {
              _context.next = 14;
              break;
            }

            _context.next = 13;
            return toPin(input);

          case 13:
            return _context.abrupt("return", _context.sent);

          case 14:
            if (!input[Symbol.iterator]) {
              _context.next = 80;
              break;
            }

            iterator = input[Symbol.iterator]();
            first = iterator.next();

            if (!first.done) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return", iterator);

          case 19:
            if (!(CID.isCID(first.value) || first.value instanceof String || typeof first.value === 'string')) {
              _context.next = 49;
              break;
            }

            _context.next = 22;
            return toPin({
              cid: first.value
            });

          case 22:
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            _context.prev = 25;
            _iterator3 = iterator[Symbol.iterator]();

          case 27:
            if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
              _context.next = 34;
              break;
            }

            cid = _step3.value;
            _context.next = 31;
            return toPin({
              cid: cid
            });

          case 31:
            _iteratorNormalCompletion3 = true;
            _context.next = 27;
            break;

          case 34:
            _context.next = 40;
            break;

          case 36:
            _context.prev = 36;
            _context.t0 = _context["catch"](25);
            _didIteratorError3 = true;
            _iteratorError3 = _context.t0;

          case 40:
            _context.prev = 40;
            _context.prev = 41;

            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }

          case 43:
            _context.prev = 43;

            if (!_didIteratorError3) {
              _context.next = 46;
              break;
            }

            throw _iteratorError3;

          case 46:
            return _context.finish(43);

          case 47:
            return _context.finish(40);

          case 48:
            return _context.abrupt("return");

          case 49:
            if (!(first.value.cid != null || first.value.path != null)) {
              _context.next = 79;
              break;
            }

            _context.next = 52;
            return toPin(first.value);

          case 52:
            _iteratorNormalCompletion4 = true;
            _didIteratorError4 = false;
            _iteratorError4 = undefined;
            _context.prev = 55;
            _iterator4 = iterator[Symbol.iterator]();

          case 57:
            if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
              _context.next = 64;
              break;
            }

            obj = _step4.value;
            _context.next = 61;
            return toPin(obj);

          case 61:
            _iteratorNormalCompletion4 = true;
            _context.next = 57;
            break;

          case 64:
            _context.next = 70;
            break;

          case 66:
            _context.prev = 66;
            _context.t1 = _context["catch"](55);
            _didIteratorError4 = true;
            _iteratorError4 = _context.t1;

          case 70:
            _context.prev = 70;
            _context.prev = 71;

            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }

          case 73:
            _context.prev = 73;

            if (!_didIteratorError4) {
              _context.next = 76;
              break;
            }

            throw _iteratorError4;

          case 76:
            return _context.finish(73);

          case 77:
            return _context.finish(70);

          case 78:
            return _context.abrupt("return");

          case 79:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 80:
            if (!input[Symbol.asyncIterator]) {
              _context.next = 164;
              break;
            }

            _iterator5 = input[Symbol.asyncIterator]();
            _context.next = 84;
            return _awaitAsyncGenerator(_iterator5.next());

          case 84:
            _first = _context.sent;

            if (!_first.done) {
              _context.next = 87;
              break;
            }

            return _context.abrupt("return", _iterator5);

          case 87:
            if (!(CID.isCID(_first.value) || _first.value instanceof String || typeof _first.value === 'string')) {
              _context.next = 125;
              break;
            }

            _context.next = 90;
            return toPin({
              cid: _first.value
            });

          case 90:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 92;
            _iterator = _asyncIterator(_iterator5);

          case 94:
            _context.next = 96;
            return _awaitAsyncGenerator(_iterator.next());

          case 96:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 100;
            return _awaitAsyncGenerator(_step.value);

          case 100:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 108;
              break;
            }

            _cid = _value;
            _context.next = 105;
            return toPin({
              cid: _cid
            });

          case 105:
            _iteratorNormalCompletion = true;
            _context.next = 94;
            break;

          case 108:
            _context.next = 114;
            break;

          case 110:
            _context.prev = 110;
            _context.t2 = _context["catch"](92);
            _didIteratorError = true;
            _iteratorError = _context.t2;

          case 114:
            _context.prev = 114;
            _context.prev = 115;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 119;
              break;
            }

            _context.next = 119;
            return _awaitAsyncGenerator(_iterator.return());

          case 119:
            _context.prev = 119;

            if (!_didIteratorError) {
              _context.next = 122;
              break;
            }

            throw _iteratorError;

          case 122:
            return _context.finish(119);

          case 123:
            return _context.finish(114);

          case 124:
            return _context.abrupt("return");

          case 125:
            if (!(_first.value.cid != null || _first.value.path != null)) {
              _context.next = 163;
              break;
            }

            _context.next = 128;
            return toPin(_first.value);

          case 128:
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context.prev = 130;
            _iterator2 = _asyncIterator(_iterator5);

          case 132:
            _context.next = 134;
            return _awaitAsyncGenerator(_iterator2.next());

          case 134:
            _step2 = _context.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context.next = 138;
            return _awaitAsyncGenerator(_step2.value);

          case 138:
            _value2 = _context.sent;

            if (_iteratorNormalCompletion2) {
              _context.next = 146;
              break;
            }

            _obj = _value2;
            _context.next = 143;
            return toPin(_obj);

          case 143:
            _iteratorNormalCompletion2 = true;
            _context.next = 132;
            break;

          case 146:
            _context.next = 152;
            break;

          case 148:
            _context.prev = 148;
            _context.t3 = _context["catch"](130);
            _didIteratorError2 = true;
            _iteratorError2 = _context.t3;

          case 152:
            _context.prev = 152;
            _context.prev = 153;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context.next = 157;
              break;
            }

            _context.next = 157;
            return _awaitAsyncGenerator(_iterator2.return());

          case 157:
            _context.prev = 157;

            if (!_didIteratorError2) {
              _context.next = 160;
              break;
            }

            throw _iteratorError2;

          case 160:
            return _context.finish(157);

          case 161:
            return _context.finish(152);

          case 162:
            return _context.abrupt("return");

          case 163:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 164:
            throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 165:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[25, 36, 40, 48], [41,, 43, 47], [55, 66, 70, 78], [71,, 73, 77], [92, 110, 114, 124], [115,, 119, 123], [130, 148, 152, 162], [153,, 157, 161]]);
  }));

  function normaliseInput(_x) {
    return _normaliseInput.apply(this, arguments);
  }

  return normaliseInput;
}();
/**
 * @param {ToPinWithPath|ToPinWithCID} input
 * @returns {Pin}
 */


function toPin(input) {
  var pin = {
    path: input.path == null ? input.cid : "".concat(input.path),
    recursive: input.recursive !== false
  };

  if (input.metadata != null) {
    pin.metadata = input.metadata;
  }

  return pin;
}
/**
 * @typedef {Object} ToPinWithPath
 * @property {string | InstanceType<typeof window.String> | CID} path
 * @property {undefined} [cid]
 * @property {boolean} [recursive]
 * @property {any} [metadata]
 *
 * @typedef {Object} ToPinWithCID
 * @property {undefined} [path]
 * @property {CID} cid
 * @property {boolean} [recursive]
 * @property {any} [metadata]
 *
 * @typedef {CID|string|InstanceType<typeof window.String>|ToPinWithPath|ToPinWithPath} ToPin
 * @typedef {ToPin|Iterable<ToPin>|AsyncIterable<ToPin>} Source
 *
 * @typedef {Object} Pin
 * @property {string|CID} path
 * @property {boolean} recursive
 * @property {any} [metadata]
 */